import React from "react"
import PropTypes from 'prop-types'
import { Route, Redirect } from "react-router-dom"

const AppRoute = ({
  component: Component,
  layout: Layout,
  isAuthProtected,
  ...rest
}) => (
  <Route
    {...rest}
    render={props => {
      const authUser = localStorage.getItem("authUser")
      const user = localStorage.getItem("user")
      const parsedUser = user ? JSON.parse(user) : null
      const isPartner = parsedUser?.role === "partner"
      const isPartnerRoute = props.location.pathname.startsWith("/partner")

      if (isAuthProtected && !authUser) {
        localStorage.removeItem("user")
        localStorage.removeItem("authUser")
        return (
          <Redirect
            to={{ pathname: "/login", state: { from: props.location } }}
          />
        )
      }

      if (isAuthProtected && isPartner && !isPartnerRoute) {
        return <Redirect to="/partner/dashboard" />
      }

      return (
        <Layout>
          <Component {...props} />
        </Layout>
      )
    }}
  />
)

AppRoute.propTypes = {
  isAuthProtected: PropTypes.bool,
  component: PropTypes.any,
  location: PropTypes.object,
  layout: PropTypes.any
}

export default AppRoute
